var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StatisticCardVertical',{staticClass:"m-0",attrs:{"color":_vm.statistics.color,"icon":_vm.statistics.icon,"statistic":_vm.statistics.statistic,"statistic-title":_vm.statistics.statisticTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }